import React from 'react';
import $ from 'jquery';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as offerActions from '../../../redux/newOffer';
import { chunk } from '../../../helpers';
import { OfferContainerImage } from '../../Common';
import '../Offer.css';

interface State {
  chosen: Array<any>;
}

class ImageContainer extends React.Component<{ images: Array<any>; returnImage: Function }, State> {
  state: State = { chosen: [] };

  chooseImage(item) {
    if (!this.state.chosen.map((x) => x.id === item.id).some((x) => !!x))
      this.setState({ chosen: [...this.state.chosen, item] });
    else this.setState({ chosen: this.state.chosen.filter((x) => x.id !== item.id) });
  }

  saveImage() {
    $('#imageContainerModal').modal('hide');
    this.setState({ chosen: [] });
    this.props.returnImage(this.state.chosen);
  }

  isChosen(item) {
    return this.state.chosen.map((x) => x.id === item.id).some((x) => !!x);
  }

  render() {
    return (
      <div
        className="modal fade"
        style={{ zIndex: 10000000 }}
        id="imageContainerModal"
        role="dialog"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              <h4 className="modal-title"> </h4>
            </div>
            <div className="modal-body">
              <div style={{ height: '300px', overflowY: 'scroll', overflowX: 'hidden' }}>
                {chunk(this.props.images, 3).map((items, rowIndex) => (
                  <div className="row" key={rowIndex}>
                    {items.map((item, index) => (
                      <div className="col-md-4" key={index}>
                        <div style={{ position: 'relative' }}>
                          <OfferContainerImage
                            src={item.path}
                            alt=""
                            onClick={() => this.chooseImage(item)}
                          />
                          {this.isChosen(item) ? <div className="download-checkmark">✓</div> : null}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-info"
                onClick={() => this.saveImage()}
                disabled={this.state.chosen.length === 0}
              >
                Select images
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state): any {
  return {
    businessId: state.business.business_id,
    offer: state.offer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    offerActions: bindActionCreators(offerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageContainer);
